/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryBreadcrumbListResponse } from './RevisdomAPIViewModelsEntryBreadcrumbListResponse';
import {
    RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSON,
    RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSON,
    RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryBreadcrumbListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1BreadcrumbListResponse
 */
export interface ApiResponse1BreadcrumbListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1BreadcrumbListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1BreadcrumbListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryBreadcrumbListResponse}
     * @memberof ApiResponse1BreadcrumbListResponse
     */
    data?: RevisdomAPIViewModelsEntryBreadcrumbListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1BreadcrumbListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1BreadcrumbListResponse interface.
 */
export function instanceOfApiResponse1BreadcrumbListResponse(value: object): value is ApiResponse1BreadcrumbListResponse {
    return true;
}

export function ApiResponse1BreadcrumbListResponseFromJSON(json: any): ApiResponse1BreadcrumbListResponse {
    return ApiResponse1BreadcrumbListResponseFromJSONTyped(json, false);
}

export function ApiResponse1BreadcrumbListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1BreadcrumbListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1BreadcrumbListResponseToJSON(json: any): ApiResponse1BreadcrumbListResponse {
    return ApiResponse1BreadcrumbListResponseToJSONTyped(json, false);
}

export function ApiResponse1BreadcrumbListResponseToJSONTyped(value?: ApiResponse1BreadcrumbListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

